import React from 'react';
import BillingSettingsCard from '../BillingSettingsCard';
import WorkspaceVendorCategories from './WorkspaceVendorCategories';
import WorkspaceWhatsAppSection from './WorkspaceWhatsAppSection';
import { getActiveProjectId } from '../../utils/session';

const CreateProjectFirst: React.FC<{ title: string }> = ({ title }) => (
  <div className="settings-card">
    <h4 className="settings-card-title">{title}</h4>
    <p className="settings-card-hint">Create a project first.</p>
  </div>
);

/**
 * What is set once for the whole workspace. Owners see all of it; an admin sees WhatsApp only
 * (Billing and Vendor categories are owner only). Vendor categories and WhatsApp keys are read and written
 * through project-scoped routes until account-level ones exist (ans-backend#321), so they need a project.
 */
const WorkspaceSettingsSections: React.FC<{ isOwner: boolean }> = ({ isOwner }) => {
  const hasProject = Boolean(getActiveProjectId());
  return (
    <div className="settings-section">
      {isOwner && <BillingSettingsCard />}
      {isOwner && (hasProject ? <WorkspaceVendorCategories /> : <CreateProjectFirst title="Vendor categories" />)}
      {hasProject ? <WorkspaceWhatsAppSection /> : <CreateProjectFirst title="WhatsApp Business" />}
    </div>
  );
};

export default WorkspaceSettingsSections;
